import { useQuery } from "@tanstack/react-query";
import type { RegistryGenre } from "../../registry";

export function useGenres() {
  return useQuery<RegistryGenre[]>({
    queryKey: ["genres"],
    queryFn: () => fetch("/api/books/genres/").then((r) => r.json()),
  });
}
